import { I18nt } from 'utils';
import styles from './BotiquinCard.module.less';
import marker from '../../assets/images/marker.svg';
import { MedicineBoxOutlined } from '@ant-design/icons';
import { Botiquin } from 'utils/interfaces';
import { Button } from 'antd';
import { useConsultaMedicamentos } from 'pages/ConsultaMedicamentos/ConsultaMedicamentosContext';

interface Props {
	botiquin: Botiquin;
}

export default function BotiquinCard({ botiquin }: Props) {
	const { dispatch } = useConsultaMedicamentos();
	const url = `https://www.google.com/maps/dir/?api=1&destination=${botiquin.latitud},${botiquin.longitud}`;

	const reservar = () => {
		dispatch({
			type: 'setBotiquinForReservation',
			payload: botiquin,
		});
	};

	return (
		<div className={styles.botiquinCard}>
			<div className={styles.botiquinCardBody}>
				<div className={styles.header}>
					<span>
						<MedicineBoxOutlined />
					</span>
					<h5>{botiquin.botiquin.toLocaleUpperCase()}</h5>
				</div>
				<table>
					<tr>
						<td>
							<strong>{I18nt('direccion')}:&nbsp;</strong>
						</td>
						<td>{botiquin.ubicacion}</td>
					</tr>
				</table>
				<div className={styles.directionsLink}>
					<a href={url} target='_blank' rel='noreferrer'>
						<img src={marker} alt={I18nt('como_llegar')} />
						&nbsp;
						{I18nt('como_llegar')}
					</a>
				</div>
				<div>
					<Button block type='primary' onClick={reservar}>
						{I18nt('reservar_medicamento')}
					</Button>
				</div>
			</div>
		</div>
	);
}
